import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';  // Use useNavigate for React Router v6
import './style.css';
import { useAuth } from '../../Context/UserContext/index.tsx'; // Importing your AuthContext

const VideoPage = () => {
  const { id } = useParams();
  const navigate = useNavigate(); // Using navigate instead of history
  const { courseId,username,batchNo } = useAuth();  // Getting the courseId from context
  const [videoUrl, setVideoUrl] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);  // State to track if video is completed
  const [isVideoFinished, setIsVideoFinished] = useState(false); // State to track video completion
  const videoRef = useRef(null);  // Ref to the video element

  // Define different video sets for different courseId
  const videoMapFORT = {
    '1': '/videos/module1.mp4',
    '2': '/videos/module2.mp4',
    '3': '/videos/module3.mp4',
    '4': '/videos/module4.mp4',
    '5': '/videos/module5.mp4',
    '6': '/videos/module6.mp4',
    '7': '/videos/module7.mp4',
  };

  const videoMapOther = {
    '1': '/videos/other/module1.mp4',
    '2': '/videos/other/module2.mp4',
    '3': '/videos/other/module3.mp4',
    '4': '/videos/other/module4.mp4',
    '5': '/videos/other/module5.mp4',
    '6': '/videos/other/module6.mp4',
    '7': '/videos/other/module7.mp4',
  };

  useEffect(() => {
    // Check if the courseId is 'FORT' or another course, and then select the appropriate video map
    const videoMap = courseId === 'FORT' ? videoMapFORT : videoMapOther;

    if (id && videoMap[id]) {
      setVideoUrl(videoMap[id]);
      setIsCompleted(false);  // Reset the completion state on course change
      setIsVideoFinished(false); // Reset video finished state
    } else {
      setVideoUrl('');
    }
  }, [id, courseId]);

  // Detect when the video ends
  const handleVideoEnd = () => {
    setIsVideoFinished(true);  // Mark the video as finished
  };




const handleCompleteVideo = async () => {
  try {
    const response = await fetch('https://elearn-api.onrender.com/api/insertVideoCompletion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        NricID: username,
        TrainingId: `Module ${id}`,
        BatchNo: batchNo
      }),
    });

    if (response.ok) {
      alert('Video marked as completed!');
      setIsCompleted(true);
      setIsVideoFinished(false);
   await fetch(`https://elearn-api.onrender.com/api/increment-currentsts/${username}/${batchNo}/${courseId}`, {
        method: 'POST',
      });
      // Mark current module as completed locally
      localStorage.setItem(`module_${id}_completed`, 'true');

      // Unlock next MCQ (mcq_<next_module>)
      const nextModule = parseInt(id) + 1;
      localStorage.setItem(`mcq_${nextModule}_unlocked`, 'true');

     
      // Notify sidebar or other listeners about storage change
      window.dispatchEvent(new Event('storage'));
    } else {
      const errorData = await response.json();
      alert(`Error: ${errorData.message || 'Failed to mark completion'}`);
    }
  } catch (error) {
    console.error('Error submitting video completion:', error);
    alert('Server error while marking video completion.');
  }
};



  return (
    <div className="report-container">
      {videoUrl ? (
        <>
          <h2 className="video-heading">Module {id}</h2>
          <div className="video-wrapper">
            <video
              ref={videoRef}
              key={videoUrl}
              controls
              onEnded={handleVideoEnd} // Triggered when the video ends
            >
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Complete tutorial button, visible only after the video ends */}
          {!isCompleted && isVideoFinished && (
            <button
              onClick={handleCompleteVideo}
              className="complete-btn"
            >
              Completed Video Tutorial
            </button>
          )}
        </>
      ) : (
        <p>Video not available for this module.</p>
      )}
    </div>
  );
};

export default VideoPage;
